import React from 'react';
import { Provider } from 'react-redux';

import store from 'client/redux/store';
import OuterLayerGallery from 'ugc/components/ugcGallery/OuterLayerGallery';

export default function RouteMontage({
    match: {
        params: { promoUUID }
    }
}) {
    return (
        <Provider store={store}>
            <OuterLayerGallery promoUUID={promoUUID} />
        </Provider>
    );
}
